<template>
    <div>
        <v-row>
            <ActionDropdown 
                :items="actions"
                context="Mappings"
                :alvqa="alvqa"
                cols="2"
            /> 
            
            <v-col 
                align-self="center"
                cols="4"
                class="v-label theme--light mt-3"
            >
                <BaseHeaderStats 
                    context="Mappings" 
                    typeStats="LIST"
                    :alvqa="alvqa + '-list'" />
            </v-col>
            <v-spacer /> 
            <v-col 
                cols="2"
                align-self="center"
            >
                <BaseButton 
                    label="lang_ACCOUNT_MAPPINGS_CAPTION_NEW_MAPPING"
                    :to="{ name: editForm, params: { alvId: 'new' } }"
                    block
                    color="buttonNewEntity"
                    :alvqa="alvqa + '-list-button-new'"
                />
            </v-col> 
        </v-row>
    </div>

</template>

<script>
import BaseHeaderStats from '@/components/_base/BaseHeaderStats'
import ActionDropdown from '@/components/_actions/ActionDropdown'
import BaseButton from '@/components/_buttons/BaseButton'

export default {
    name: "MappingsTopSlot",
    data() {
        return {
            editForm: "MappingsEdit",
            alvqa: "mappings"
        }
    },
    components: {
        BaseButton,
        ActionDropdown,
        BaseHeaderStats
    },
    computed: {
        actions() {
            let filtersSetOnRequest = this.$store.getters.getMappingsFiltersOnRequest
            let selectedMaintainer = !('maintainer' in filtersSetOnRequest) ? null : filtersSetOnRequest.maintainer
            
            let retArr = [
                {
                    text: this.$t('lang_GENERIC_CAPTION_COPY'), 
                    value: 'copy',
                    alvqa: this.alvqa + '-list-action-dropdown-copy'
                },
                { 
                    text: this.$t('lang_GENERIC_CAPTION_DELETE'), 
                    value: 'delete', 
                    alvqa: this.alvqa + '-list-action-dropdown-delete'
                }
            ]
            if (selectedMaintainer !== 'self' && !Array.isArray(selectedMaintainer) && selectedMaintainer !== null) {
                retArr = [
                    {
                        text: this.$t('lang_ACCOUNT_MAPPINGS_CAPTION_ADOPT'), 
                        value: 'adopt',
                        alvqa: this.alvqa + '-list-action-dropdown-make-my-own'
                    }
                ]
            }

            return retArr
        },
    },
    methods: {
    }
}
</script>